<template>
  <div>
    <el-popover
      ref="popover"
      @show="showPopover = true"
      @hide="showPopover = false"
      v-model="showPopover"
      placement="bottom"
      width="850"
      trigger="click"
    >
      <el-input
        :value="selectUser ? selectUser.name : null"
        slot="reference"
        placeholder="请选择用户"
        :suffix-icon="showPopover ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
        readonly
      ></el-input>
      <div style="position: relative; height: 25px">
        <i
          @click="showPopover = false"
          class="el-icon-close"
          style="font-size: large; position: absolute; right: 0px"
        ></i>
      </div>
      <transition name="el-zoom-in-top">
        <el-form inline v-show="searchDataFormShow" :model="searchData">
          <el-form-item>
            <el-input
              placeholder="账号/姓名"
              clearable
              prefix-icon="el-icon-search"
              v-model="searchData.searchInputValue"
              style="width: 250px"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="用户身份">
            <el-select
              v-model="searchData.isAdmin"
              placeholder="是否是管理员"
              clearable
              @change="changeAndSearch"
              :style="{
                width: '180px',
              }"
            >
              <el-option :key="true" label="管理员" :value="true"> </el-option>
              <el-option :key="false" label="非管理员" :value="false">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              size="mini"
              @click="changeAndSearch"
            >
              搜索
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button
              icon="el-icon-refresh"
              size="mini"
              @click="resetAndSearch"
            >
              重置
            </el-button>
          </el-form-item>
        </el-form>
      </transition>
      <el-form inline>
        <el-tooltip
          effect="dark"
          content="显示/隐藏搜索栏"
          placement="top-start"
        >
          <el-button
            icon="el-icon-search"
            size="mini"
            circle
            @click="searchDataFormShow = !searchDataFormShow"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          effect="dark"
          content="将已选用户信息清空"
          placement="top-start"
        >
          <el-button
            icon="el-icon-delete"
            size="mini"
            plain
            type="primary"
            @click="select()"
          >
            清除已选
          </el-button>
        </el-tooltip>
      </el-form>
      <el-table
        v-loading="searchLoading"
        :data="searchRes && searchRes.data ? searchRes.data : []"
        stripe
        ref="refsTable"
        @sort-change="sortChange"
        height="400px"
      >
        <el-table-column
          prop="account"
          label="账号"
          min-width="150"
          align="left"
          header-align="center"
          sortable="custom"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          min-width="200"
          align="left"
          header-align="center"
          sortable="custom"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.isAdmin">管理员</el-tag>
            {{ scope.row.name }}
          </template>
        </el-table-column>
        <el-table-column
          label="可用门诊部"
          width="150"
          align="left"
          header-align="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{
              scope.row.userOrgList
                .map((d) => d.organization)
                .sort((a, b) => a.no - b.no)
                .map((d) => d.name)
                .join("、")
            }}
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          header-align="center"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <el-button @click.native.stop="select(scope.row)" type="primary">
              选择
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="searchRes && searchRes.pageInfo"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchRes.pageInfo.page"
        :page-sizes="[5, 10, 20, 50, 100]"
        :page-size="searchRes.pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="searchRes.total"
      >
      </el-pagination>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: "UserSelect",
  props: {
    value: [Object],
  },
  watch: {
    value: {
      handler(val) {
        this.selectUser = this.value;
      },
      immediate: true,
    },
    showPopover: {
      handler(val) {
        if (val) {
          this.search(true);
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      searchDataFormShow: true,

      searchLoading: false,
      searchData: {
        searchInputValue: null,
        isAdmin: null,
      },
      searchParam: {
        quickSearchInfoList: [
          {
            columns: ["account", "name"],
            quickSearchValue: null,
          },
        ],
        isAdmin: null,
        pageInfo: {
          page: 1,
          pageSize: 20,
        },
        sortInfo: null,
      },
      searchRes: {},
      selectUser: null,
      showPopover: false,
    };
  },
  methods: {
    handleSizeChange(val) {
      this.searchParam.pageInfo.pageSize = val;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    handleCurrentChange(val) {
      this.searchParam.pageInfo.page = val;
      this.search(false, {
        showSuccessMessage: true,
      });
    },
    changeAndSearch() {
      this.searchParam.quickSearchInfoList[0].quickSearchValue =
        this.searchData.searchInputValue;
      this.searchParam.isAdmin = this.searchData.isAdmin;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    sortChange(val) {
      this.searchParam.sortInfo =
        val && val.order
          ? {
              columnName: val.prop,
              order: val.order.replace("ending", "").toUpperCase(),
            }
          : null;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    resetAndSearch() {
      this.searchData = this.$options.data().searchData;
      this.changeAndSearch();
    },
    async search(init, args) {
      if (init) {
        this.searchParam.pageInfo.page = 1;
      }
      this.searchLoading = true;
      let requestRes = await this.$api.user_findPageForSelect(
        this.searchParam,
        args
      );
      if (requestRes && requestRes.success) {
        this.searchRes = requestRes;
        this.searchRes.pageInfo = requestRes.pageInfo;
        this.$nextTick(() => {
          this.$refs.refsTable.doLayout();
        });
      }
      if (requestRes.pageCount == 0) {
        this.searchRes = null;
      }
      setTimeout(() => {
        this.searchLoading = false;
      }, 200);
    },
    select(user) {
      this.selectUser = user;
      this.$emit("select", user);
      this.showPopover = false;
    },
  },
  mounted() {},
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/UserSelect.vue